import React from "react";

export default function SubmitConfirmationModal({openSendModal,submitExam,send}) {
 
  //  console.log("MODAL")
    return(<div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end min-h-screen pt-4 px-4 pb-20 sm:block sm:p-0">

      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
  
     
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
  

      <div class="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
           
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
            </div>
            <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg lg:text-xl leading-6 font-medium text-gray-900" id="modal-title">Entregar Examen</h3>
              <div class="mt-2">
                <p class="text-sm lg:text-lg text-gray-500 text-left">Está a punto de entregar el examen. <b>¿Desea confirmar la entrega?</b></p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={()=>{submitExam(true); send(); openSendModal(false)}}>Confirmar</button>
          <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-500 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={()=>openSendModal(false)}>Cancelar</button>
        </div>
      </div>
    </div>
  </div>)
    // return (
    //   <div className="fixed top-0 left-0 right-0 z-50 hidden overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full">
    //         <div
    //           className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
    //         >
    //           <div className="relative w-auto my-6 mx-auto max-w-3xl">
    //             {/*content*/}
    //             <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
    //               {/*header*/}
    //               <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
    //                 <h3 className="text-3xl font-semibold">
    //                   Finalizar Examen
    //                 </h3>
    //                 <button
    //                   className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
    //                   onClick={() => {setShowModal(false)
    //                   toConfirm(false)}}
    //                 >
    //                   <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
    //                     ×
    //                   </span>
    //                 </button>
    //               </div>
    //               {/*body*/}
    //               <div className="relative p-6 flex-auto">
    //                 <p className="my-4 text-slate-500 text-lg leading-relaxed">
    //                  ¿Está seguro/a de que quiere entregar el examen?
    //                 </p>
    //               </div>
    //               {/*footer*/}
    //               <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
    //                 <button
    //                   className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
    //                   type="button"
    //                   onClick={() => {setShowModal(false)
    //                     toConfirm(false)}}
    //                 >
    //                   Cancelar
    //                 </button>
    //                 <button
    //                   className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
    //                   type="button"
    //                   onClick={() => 
    //                     confirmSubmition()
    //                    }
    //                 >
    //                   Confirmar
    //                 </button>
    //               </div>
    //             </div>
    //           </div>
           
    //         <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
  
    //   <div/>
    //   </div>
    //   <div/>
    //   </div>
    // )


}